export default __webpack_public_path__ + "static/media/0197.324bbacf.jpg";